import { EntityReferences } from "../models/mappers";
import { EntityName } from "./entityNames";
import { AnyEntityField } from "./metadata";

export const contactFields = [
  "contactid", // UID
  "modifiedon", // Date
  "firstname", // Text
  "lastname", // Text
  "jobtitle", // Text
  "emailaddress1", // Email
  "parentcustomerid_account", // Lookup - accounts
  "gaming_HubLastUpdateByContactId", // Lookup - contact
  "ownerid", // Owner
  "telephone1", // Text
  "gaming_onboardinguserid", // Text
  "gaming_onboardinghubcreated", // Boolean
  "fullname", // Text
  "statecode", // Choice
  "statuscode", // Choice
  "playfab_gmid", // Text
  "playfab_contactgamestate", // Text
  "gaming_hubenabled", // Text
  "gaming_ishubadmin", // Choice
] as const;

export const contactReferences: EntityReferences<EntityName.contact> = {
  [EntityName.account]: ["parentcustomerid_account"],
  [EntityName.contact]: ["gaming_HubLastUpdateByContactId"],
};

export const contactKey: AnyEntityField<EntityName.contact> = "contactid";
